"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../lib");

var _common = require("../common");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MediaSize =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(MediaSize, _PureComponent);

  function MediaSize(props) {
    var _this;

    _classCallCheck(this, MediaSize);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaSize).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleCheckMediaSize", function (e) {
      var _this$props = _this.props,
          tablet = _this$props.tablet,
          mobile = _this$props.mobile;
      var windowWidth = window.innerWidth;
      var isDesktop = windowWidth > tablet;
      var isTablet = windowWidth > mobile && windowWidth <= tablet;
      var isMobile = windowWidth <= mobile;

      if (isDesktop !== _this.state.isDesktop || isTablet !== _this.state.isTablet || isMobile !== _this.state.isMobile) {
        _this.setState({
          isDesktop: isDesktop,
          isTablet: isTablet,
          isMobile: isMobile
        }, function () {
          var onChange = _this.props.onChange;

          if (onChange) {
            onChange(e, _this.state);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [];
      var propNames = ['isDesktop', 'isTablet', 'isMobile'];
      (0, _lib.addClassByPropName)(names, _this.state, propNames);
      return names.join(' ');
    });

    var _tablet = props.tablet,
        _mobile = props.mobile;
    var _windowWidth = window.innerWidth;
    _this.state = {
      isDesktop: _windowWidth > _tablet,
      isTablet: _windowWidth > _mobile && _windowWidth <= _tablet,
      isMobile: _windowWidth <= _mobile
    };
    return _this;
  }

  _createClass(MediaSize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleCheckMediaSize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleCheckMediaSize);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var classNames = this.classNames();
      return (0, _lib.getRenderProps)(children, this.state, classNames);
    }
  }]);

  return MediaSize;
}(_react.PureComponent);

exports["default"] = MediaSize;

_defineProperty(MediaSize, "propTypes", {
  children: _common.customPropTypes.render.isRequired,
  tablet: _propTypes["default"].number,
  mobile: _propTypes["default"].number,
  onChange: _propTypes["default"].func
});

_defineProperty(MediaSize, "defaultProps", {
  tablet: 991,
  mobile: 767,
  onChange: null
});